module.exports = __webpack_public_path__ + "img/icon-wallet-link.af4ad70a.png";